import LabelProvider from "core/components/label/LabelProvider";
import CatalogLabels from "panels/catalog/Catalog.labels";

export default LabelProvider.create({

	...CatalogLabels.getData(),

	// Programs

	ProgramsEmptyTitle: { k: 'programs.empty.title', v: 'No Programs Found' },

	ProgramsEmptyDesc: { k: 'programs.empty.desc', v: '' },

	ProgramNotFoundTitle: { k: 'program.notfound.title', v: 'Program Not Found' },

	ProgramNotFoundDesc: { k: 'program.notfound.desc', v: '' },

	ProgramView: { k: "program.view", v: "View Details" },

	Tracks: { k: "program.tracks", v: "Tracks" },

	ResumeLast: { k: "program.resume", v: "Continue", argNames: ["title"] },

	// Program Tracks

	TrackView: { k: "programTrack.view", v: "View Details" },

	// Program Track Courses

	TrackProductRequired: { k: "programTrackProduct.required", v: "Required" },

	// Progress

	Progress: { k: "program.progress", v: "${completed} of ${total} Completed", argNames: ["completed", "total"] },

	ProgressCredits: { k: "program.progress.credits", v: "${completed} of ${total} Credits Earned", argNames: ["completed", "total"] },

	Focus: { k: 'program.focus', v: 'Focus Area Based on Self Assessment' }

});



// WEBPACK FOOTER //
// ./src/panels/catalog/Program.labels.ts